import NiceModal from '@ebay/nice-modal-react';

import { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import IntegerInput from 'components/field/IntegerInput';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import * as S from './BoxInput.styled';
import BoxModal from './BoxModal';

const BoxInput = (props) => {
	const { fieldName, viewMode } = props;

	const { getValues } = useFormContext();

	return viewMode ? (
		<IntegerInput value={getValues(`${fieldName}.boxes`).length} viewMode={viewMode} />
	) : (
		<InputComponent {...props} />
	);
};

const InputComponent = (props) => {
	const { fieldName, orderID, fetchDeliveryFee, rowIndex, required = true, disabled } = props;
	const defaultBoxState = useSelector((state) => state.user.defaultBox);
	const defaultBox = defaultBoxState
		? {
				ID: defaultBoxState.id,
				width: defaultBoxState.width,
				height: defaultBoxState.height,
				length: defaultBoxState.length,
				name: defaultBoxState.boxName,
				weight: 1
			}
		: { width: 10, height: 10, length: 10, weight: 1 };

	const formMethods = useFormContext();
	const {
		control,
		formState: { errors }
	} = formMethods;

	const { fields, append, remove } = useFieldArray({
		control,
		name: `${fieldName}.boxes`
	});

	const [inputValue, setInputValue] = useState(fields.length);

	const handleChangeValue = (value) => {
		const newValue = value === '' ? value : value < 0 ? 1 : value > 20 ? 20 : value;

		const fieldsLength = fields.length ?? 0;
		if (newValue > fieldsLength) {
			const count = newValue - fieldsLength;
			const newFields = count > 1 ? [...Array(count)].map((_) => defaultBox) : defaultBox;
			append(newFields);
		} else if (newValue < fieldsLength) {
			const count = fieldsLength - newValue;
			const removeIndex = count > 1 ? [...Array(count)].map((i) => fields.length - (i + 1)) : fields.length - 1;
			remove(removeIndex);
		}

		setInputValue(newValue);
	};

	const isMobile = useMediaQuery(Breakpoints.mobile);

	return (
		<S.BoxInputContainer>
			<IntegerInput
				className="boxEditorInput"
				value={inputValue}
				setValue={handleChangeValue}
				errorMessage={errors?.items?.[rowIndex]?.boxes?.message}
				min={1}
				max={20}
				showArrows={false}
				disabled={disabled}
			/>
			<Button
				size="small"
				icon={isMobile ? faEdit : ''}
				label={isMobile ? '' : 'edit'}
				onClick={() =>
					NiceModal.show(BoxModal, {
						orderID,
						formMethods,
						fieldName,
						setInputValue,
						required,
						fetchDeliveryFee
					})
				}
			/>
		</S.BoxInputContainer>
	);
};

export default BoxInput;
